import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";

//Components
import Modal, { ModalBody, ModalFooter } from "Components/Modal";
import { Button } from '@gpstrackit/gtc-react-controls';
import { NotificationManager } from "Components/Notifications";

//Actions
import {
    deleteMaintenanceWarningsEvents,
    reset
} from './redux/slice';
const DeleteMaintenanceWarningEvent = (props) => {

    const { messages } = useIntl();
    const dispatch = useDispatch();

    //Redux States
    const { open, loading, data, result, error } = useSelector(state => state.warningsDeleteRedux)

    const closeModal = () => {
        dispatch(reset())
    }

    const applyChanges = () => {
        let warningCodes = data?.warnings
        dispatch(deleteMaintenanceWarningsEvents({ ...data, warnings: warningCodes }))
    }

    useEffect(() => {
        if (result) {
            let title = (data?.bulk || data?.warnings?.length > 1) ? messages['warnings_main_delete_warnings'] : messages['warnings_main_delete_warning']
            let successMessage = (data?.bulk || data?.warnings?.length > 1) ? messages['warnings_main_success_message_delete_all'] : messages['warnings_main_success_message_delete']
            let errorMessage = (data?.bulk || data?.warnings?.length > 1) ? messages['warnings_main_error_message_delete_all'] : messages['warnings_main_error_message_delete']

            if (result?.delete) {
                NotificationManager.success(successMessage, title, 3000);
                closeModal()
            } else {
                NotificationManager.error(errorMessage, title, 3000);
                dispatch(reset({ result: null }))
            }
        }
    }, [result])

    useEffect(() => {
        if (error) {
            let title = (data?.bulk || data?.warnings?.length > 1) ? messages['warnings_main_delete_warnings'] : messages['warnings_main_delete_warning']
            let errorMessage = (data?.bulk || data?.warnings?.length > 1) ? messages['warnings_main_error_message_delete_all'] : messages['warnings_main_error_message_delete']
            NotificationManager.error(errorMessage, title, 3000);
            dispatch(reset({ error: false }))
        }
    }, [error])

    return (
        <Modal
            open={open}
            title={(data?.bulk || data?.warnings?.length > 1) ? messages['warnings_main_delete_warnings'] : `${messages['warnings_main_delete_warning']} (${messages[`warnings_main_${data?.warnings[0]}`] || data?.warnings[0]})`}
            position="right"
            size="small"
            handleClose={closeModal}
            loading={loading}
        >
            <ModalBody>
                <div style={{ padding: '0 25px', marginBottom: 30 }}>
                    {
                        data?.bulk ? <p>{messages['warnings_main_message_delete_all']}</p> : data?.warnings?.length === 1 ? <p>{messages['warnings_main_message_delete']}</p> : <p>{messages['warnings_main_message_deleted_selected']}</p>
                    }
                    <ul>
                        {
                            data?.warnings?.length > 1 && data?.warnings?.map((item, index) => {
                                return (
                                    <li key={index}>{messages[`warnings_main_${item}`] || item}</li>
                                )
                            })
                        }
                    </ul>
                </div>
            </ModalBody>
            <ModalFooter>
                <div style={{ marginLeft: 5 }}>
                    <Button
                        variant='secondary'
                        onClick={() => closeModal()}
                        style={{ marginRight: 5 }}
                    >
                        {messages['close']}
                    </Button>
                    <Button
                        variant='primary'
                        onClick={() => applyChanges()}
                    >
                        {messages['delete']}
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    )
}

export default DeleteMaintenanceWarningEvent;